import React, { useState, useEffect } from 'react'
import 'react-step-progress-bar/styles.css'
import './styles.scss'
import { useTranslation } from 'react-i18next'
import importer from '@takedapdt/biolife-core/src/importer'
const { getCssColorFromDrupalColorType } = importer('Constant/Utils', null)
import ProgressStepIcon from '../../../assets/media/icons/quest-tracker-marker.svg'
import ProgressCompleteStepIcon from '../../../assets/media/icons/icon-quest-tracker-marker.svg'
import ProgressCompleteIcon from '../../../assets/media/icons/icon-ndq-final-trophy.svg'
import { ProgressBar, Step } from 'react-step-progress-bar'

const ProgressBarComp = ({ value, totalPoints, totalSteps, showPoints, pointsToBeShown }) => {
  const { t } = useTranslation('LoyaltyGame')
  const [progress, setProgress] = useState(8)
  const [currentPointStep, setCurrentPointStep] = useState(null)

  useEffect(() => {
    value === 0 ? setProgress(8) : setProgress(value)
    if (totalSteps?.length) {
      // to get the point for the particular step getting succeeded
      let pointValue = totalSteps?.filter((step) => step?.completed)?.length - 1
      setCurrentPointStep(pointValue)
    }
  }, [value])

  return (
    <div className='progress-bar-main-container'>
      <div className='progress-bar-container'>
        <ProgressBar
          percent={progress}
          height={16}
          unfilledBackground={getCssColorFromDrupalColorType('white')}
          filledBackground={getCssColorFromDrupalColorType('titleBlue')}
          hasStepZero={false}
        >
          {totalSteps?.map((step, index) => (
            <Step key={step.sfid} transition='scale'>
              {({ accomplished, index }) =>
                index === totalSteps?.length - 1 ? (
                  <img className='progress-bar-complete-icon' width='30' height='40' src={ProgressCompleteIcon} />
                ) : accomplished ? (
                  <>
                    <img width='20' src={ProgressCompleteStepIcon} />
                    {showPoints && currentPointStep == index ? (
                      <div className='progress-bar-points-container'>
                        +{pointsToBeShown} {t('points')}
                      </div>
                    ) : null}
                  </>
                ) : (
                  <img width='16' src={ProgressStepIcon} />
                )
              }
            </Step>
          ))}
        </ProgressBar>
        <div className='progress-bar-text-container'>
          <span className='progress-bar-text'>{t('questTracker')}</span>
          <span className='progress-bar-text'>
            {totalPoints} {t('points')}
          </span>
        </div>
      </div>
    </div>
  )
}

export default ProgressBarComp
